import { i18n } from 'src/i18n';
import exporterRenders from 'src/modules/shared/exporter/exporterRenders';

export default [
  {
    name: 'id',
    label: i18n('entities.watchlist.fields.id'),
  },
  {
    name: 'name',
    label: i18n('entities.watchlist.fields.name'),
  },
  {
    name: 'description',
    label: i18n('entities.watchlist.fields.description'),
  },
  {
    name: 'companies',
    label: i18n('entities.watchlist.fields.companies'),
    render: exporterRenders.relationToMany(),
  },
  {
    name: 'createdAt',
    label: i18n('entities.watchlist.fields.createdAt'),
    render: exporterRenders.datetime(),
  },
  {
    name: 'updatedAt',
    label: i18n('entities.watchlist.fields.updatedAt'),
    render: exporterRenders.datetime(),
  },
];
